"use client";

import type { ReactNode } from "react";
import { useUser } from "@clerk/nextjs";
import AuthSignInButton from "@/components/AuthSignInButton";
import { Title as MantineTitle } from "@mantine/core";

import styles from "../styles.module.scss";

export function LockedSection({ children }: { children: ReactNode }) {
  const { isSignedIn, isLoaded } = useUser();

  if (!isLoaded) return null;
  if (isSignedIn) return <>{children}</>;

  return (
    <section className={styles.lockedCTA}>
      <MantineTitle order={2} className={styles.ctaEyebrow}>
        WANT THE COMPLETE REPORT?
      </MantineTitle>
      <AuthSignInButton>
        {/* eslint-disable-next-line no-restricted-syntax -- Clerk must clone a native element. */}
        <button className={styles.lockedBtn}>SIGN IN TO ACCESS</button>
      </AuthSignInButton>
    </section>
  );
}
